import Sidebar from "../layout/Sidebar";
import Topbar from "../layout/Topbar";
import CreateJobForm from "../components/CreateJobForm";
import "../styles/createJob.css";
import { useState } from "react";


function CreateJob() {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className="app">
      
      {/* Sidebar */}
      <Sidebar
        show={showSidebar}
        closeSidebar={() => setShowSidebar(false)}
      />

      {/* Main */}
      <div className="main">
        <Topbar toggleSidebar={() => setShowSidebar(true)} />

        <div className="page">
          <CreateJobForm />
        </div>
      </div>
    </div>
  );
}

export default CreateJob;